import { Settings } from "@mui/icons-material"
import HomeIcon from "@mui/icons-material/Home"
import LoginIcon from "@mui/icons-material/Login"
import MenuIcon from "@mui/icons-material/Menu"
import { useTheme } from "@mui/material"
import BottomNavigation from "@mui/material/BottomNavigation"
import BottomNavigationAction from "@mui/material/BottomNavigationAction"
import Paper from "@mui/material/Paper"
import { ReactElement, useState } from "react"
import { useNavigate } from "react-router-dom"

import MobileNavSideBar from "./mobileNavSideBar"
import { useAppDispatch } from "../../../hooks/useDispatch"
import { useGetUserData } from "../../../hooks/useGetUserData"
import { setShowPreferences } from "../../../redux/preferencesSlice"
import { BASE_URL, LOGIN } from "../../../router/routes"
import HideOnScroll from "../../animations/hideOnScroll"

const SETTINGS = "Settings"
const HOME = "Home"
const LOG_IN = "Log In"
const NAV = "Navigation"
const BOTTOM_NAV_HEIGHT = 80

/** Renders a bottom navigation bar for mobile devices */
const BottomNavigationBar = (): ReactElement => {
    const [isOpen, setIsOpen] = useState(false)
    const { isSignedIn } = useGetUserData()
    const navigate = useNavigate()
    const theme = useTheme()
    const dispatch = useAppDispatch()

    return (
        <>
            <MobileNavSideBar isOpen={isOpen} setIsOpen={setIsOpen} />
            <HideOnScroll>
                <Paper
                    sx={{
                        position: "fixed",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: BOTTOM_NAV_HEIGHT,
                    }}
                    elevation={4}
                >
                    <BottomNavigation
                        showLabels
                        sx={{
                            pb: 1.2,
                            height: BOTTOM_NAV_HEIGHT,
                            marginBottom: 0,
                            backgroundColor:
                                theme.palette.mode === "dark"
                                    ? theme.palette.background.contentBackground
                                    : theme.palette.background.frameBackground,
                        }}
                        onChange={(_e, newValue) => {
                            if (newValue === SETTINGS) {
                                dispatch(setShowPreferences(true))
                            }
                            if (newValue === LOG_IN) {
                                navigate(LOGIN)
                            }
                            if (newValue === HOME) {
                                navigate(BASE_URL)
                            }
                            if (newValue === NAV) {
                                setIsOpen(true)
                            }
                        }}
                    >
                        <BottomNavigationAction
                            label={HOME}
                            value={HOME}
                            icon={<HomeIcon sx={{ mb: 0.5 }} />}
                        />

                        {isSignedIn ? (
                            <BottomNavigationAction
                                label={SETTINGS}
                                value={SETTINGS}
                                icon={<Settings sx={{ mb: 0.5 }} />}
                            />
                        ) : (
                            <BottomNavigationAction
                                label={LOG_IN}
                                value={LOG_IN}
                                icon={<LoginIcon sx={{ mb: 0.5 }} />}
                            />
                        )}

                        <BottomNavigationAction
                            label={NAV}
                            value={NAV}
                            icon={<MenuIcon sx={{ mb: 0.5 }} />}
                        />
                    </BottomNavigation>
                </Paper>
            </HideOnScroll>
        </>
    )
}
export default BottomNavigationBar
